module.exports = __webpack_public_path__ + "img/wt7.92c1da94.png";